export const VIDEO_HERO = "/videos/hero.mp4";
export const HERO_POSTER = "/videos/hero_poster.jpg";
export const VIDEO_CINEMATIC = "/videos/reel_cinematic.mp4";
export const VIDEO_KRAMPUSSE = "/videos/reel_krampusse.mp4";
export const VIDEO_KRAMPUSSE_V2 = "/videos/reel_krampusse_v2.mp4";

export const MOUNTAIN_BG = "/img/mountain_bg.jpg";
export const MOUNTAIN_NIGHT = "/img/mountain_night.jpg";
export const ALM_IMG = "/img/alm.webp";
export const VIP_IMG = "/img/stube.webp";
export const STUBE_IMG = "/img/stube.webp";

export const TITLE_ENSEMBLE = "/brand/title_ensemble.webp";
export const SCHRIFTZUG = "/brand/schriftzug_rot.webp";

// Lokal gehostete Show-Fotos (Picdrop-Tokens laufen ab, daher lokal)
export const SHOW_IMAGES = {
  horde: "/show/horde.jpg",
  devil: "/show/closeup_devil.jpg",
  angel: "/show/angel.jpg",
  pyro: "/show/pyro.jpg",
  flying: "/show/flying.jpg",
  stage: "/show/stage.jpg",
  mask: "/show/backstage_mask.jpg",
  wagner: "/img/wagner.webp",
};

export const GALLERY = [
  "/show/trio.jpg",
  "/show/smoke.jpg",
  "/show/closeup_mask2.jpg",
  "/show/staff.jpg",
  "/show/skydive.jpg",
  "/show/thrower.jpg",
  "/show/closeup_mask3.jpg",
  "/show/fire_blast.jpg",
];

export const PICDROP_PHOTOS = "https://www.picdrop.com/hechtfischpuplicstrategiesgmbh/hSaTutKqDS";
export const PICDROP_VIDEOS = "https://www.picdrop.com/hechtfischpuplicstrategiesgmbh/w5k8mxYv7J";
export const PICDROP_REELS = "https://www.picdrop.com/hechtfischpuplicstrategiesgmbh/fE6uNGeGCT";

export const SOCIALS = {
  instagram: "https://www.instagram.com/latschenwirt",
  youtube: "https://www.youtube.com/watch?v=WUhX3lV4zZA",
  tiktok: "https://www.tiktok.com/@latschenwirt_krampus",
};

export const LAT_LOGO = "/img/lat_logo.png";
export const TICKET_SHOP_URL = "https://latschenwirt.stgdts.com/events/latschenwirt-krampus-show-2026-latschenwirt-20261120-AoH4x";
export const VIDEO_HERO_MOBILE = "/videos/hero_mobile.mp4";

export const CONTACT = {
  address: "Buchhöhstraße 122 · 5084 Großgmain",
  phone: "+43 6247 84476",
  email: "office@latschenwirt.at",
  website: "https://www.latschenwirt.at",
};
